import Button from '@components/Button';
import Row from '@components/Row';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import { requestGoogleSignIn } from '@utils/nativeUtils';
import { useTranslation } from 'react-i18next';

import RecentToolTip from '../RecentToolTip';
import GoogleIcon from './GoogleIcon';
import useSignInWithGoogle from './hooks/useSignInWithGoogle';

interface Props {
    isLastLogin?: boolean;
}

function GoogleSignInButton({ isLastLogin }:Props) {
    const { t } = useTranslation('signIn');
    const project = useProject();
    useSignInWithGoogle();

    if (project?.googleClientId) {
        return (
            <Base fullWidth
                variant='outlined'
                id='google-sign-in-button'
                onClick={requestGoogleSignIn} >
                <Row spacing={1.5}>
                    <GoogleIcon />
                    {t('google.button')}
                </Row>
                {isLastLogin && (
                    <RecentToolTip/>
                )}
            </Base>
        );
    }
    return null;
}

const Base = styled(Button)`
    border-color: ${colors.gray3} !important;
    color: ${colors.gray9} !important;
`;

export default GoogleSignInButton;
